export const SOLUTIONS = [
  ['caper', 'abate', 'pasha', 'ethic', 'reach'],
  ['debts', 'equip', 'budge', 'tiger', 'sperm'],
  ['chaff', 'hello', 'alder', 'fleet', 'forty'],
  ['bales', 'aroma', 'loyal', 'email', 'sally'],
  ['cedar', 'elite', 'dicta', 'attic', 'reach'],
  ['cargo', 'award', 'rabid', 'grill', 'oddly'],
  ['banks', 'alone', 'novel', 'kneel', 'sells'],
  ['cress', 'ranch', 'envoy', 'scowl', 'shyly'],
  ['alpha', 'lures', 'prank', 'hence', 'asked'],
  ['clout', 'lease', 'oakum', 'usurp', 'tempi'],
  ['altos', 'leapt', 'taper', 'opera', 'strap'],
  ['fills', 'idiom', 'lingo', 'logic', 'smock'],
  ['altos', 'leapt', 'tamer', 'opera', 'straw'],
  ['barbs', 'about', 'rouge', 'bugle', 'steep'],
  ['clout', 'lapse', 'opium', 'usurp', 'tempi'],
  ['barbs', 'about', 'rouge', 'bugle', 'steel'],
  ['amiss', 'media', 'idyll', 'silks', 'salsa'],
  ['altos', 'leapt', 'tamer', 'opera', 'strap'],
  ['bells', 'exult', 'lunar', 'llama', 'straw'],
  ['boles', 'opine', 'lilac', 'enact', 'sects'],
  ['abase', 'basil', 'asked', 'siege', 'elder'],
  ['acted', 'crone', 'total', 'enact', 'delta'],
  ['beams', 'enrol', 'argue', 'mouse', 'sleet'],
  ['belts', 'email', 'largo', 'tight', 'sloth'],
  ['blots', 'lapel', 'opera', 'terms', 'slash'],
  ['barns', 'await', 'racer', 'niece', 'strew'],
  ['aback', 'baron', 'argue', 'coupe', 'knees'],
  ['flaps', 'lemon', 'amble', 'polka', 'sneak'],
  ['babel', 'abate', 'bathe', 'ethic', 'leech'],
  ['aroma', 'rural', 'orbit', 'maize', 'alter'],
  ['alias', 'lynch', 'incur', 'acute', 'shrew'],
  ['brick', 'roman', 'imbue', 'cause', 'kneel'],
  ['clout', 'lapse', 'opium', 'usurp', 'temps'],
  ['cliff', 'local', 'icily', 'false', 'flyer'],
  ['click', 'lemon', 'imbue', 'coupe', 'knees'],
  ['bills', 'idiom', 'lingo', 'logic', 'smock'],
  ['amiss', 'might', 'igloo', 'shoal', 'stole'],
  ['admit', 'drama', 'madam', 'image', 'tamer'],
  ['dwarf', 'wider', 'adobe', 'rebut', 'frets'],
  ['debts', 'equip', 'bulge', 'tiger', 'sperm'],
  ['adage', 'domed', 'among', 'genie', 'edged'],
  ['adage', 'domed', 'among', 'genre', 'edged'],
  ['actor', 'coupe', 'tulip', 'opine', 'repel'],
  ['alias', 'lunch', 'incur', 'acute', 'shrew'],
  ['apple', 'peril', 'pried', 'liege', 'elder'],
  ['cents', 'equip', 'nudge', 'tiger', 'sperm'],
  ['chase', 'helix', 'alibi', 'sibyl', 'exile'],
  ['admit', 'drama', 'madam', 'image', 'tamed'],
  ['bless', 'lance', 'endow', 'scope', 'sewer'],
  ['claps', 'legal', 'agony', 'panel', 'slyly'],
  ['amiss', 'media', 'idyll', 'sills', 'salsa'],
  ['beads', 'endow', 'adage', 'dogma', 'sweat'],
  ['beams', 'elbow', 'abide', 'model', 'swell'],
  ['beams', 'elbow', 'abode', 'model', 'swell'],
  ['basic', 'aroma', 'solar', 'image', 'cares'],
  ['chick', 'human', 'imbue', 'cause', 'kneel'],
  ['amass', 'mania', 'angel', 'sieve', 'sales'],
  ['adage', 'doled', 'along', 'genie', 'edged'],
  ['babes', 'agent', 'berry', 'enrol', 'style'],
  ['beams', 'enrol', 'argue', 'mouse', 'sleep'],
  ['alpha', 'lures', 'prank', 'hence', 'askew'],
  ['bells', 'email', 'largo', 'light', 'sloth'],
  ['balls', 'adult', 'lunar', 'llama', 'straw'],
  ['ached', 'clove', 'hovel', 'event', 'delta'],
  ['beams', 'elbow', 'above', 'movie', 'sweep'],
  ['bands', 'aware', 'nasal', 'drawl', 'sells'],
  ['beads', 'expel', 'apple', 'delve', 'sleet'],
  ['amass', 'manna', 'anvil', 'snipe', 'sales'],
  ['discs', 'idiom', 'since', 'cocoa', 'smear'],
  ['beams', 'elbow', 'above', 'movie', 'sweet'],
  ['beams', 'excel', 'acute', 'meted', 'sleds'],
  ['acrid', 'credo', 'repel', 'ideal', 'dolls'],
  ['aches', 'cheap', 'hedge', 'eager', 'sperm'],
  ['brags', 'rural', 'aroma', 'gamut', 'slate'],
  ['chaff', 'hello', 'allay', 'flare', 'foyer'],
  ['brick', 'revue', 'ivory', 'curve', 'keyed'],
  ['beads', 'elbow', 'abode', 'dodge', 'sweet'],
  ['beans', 'endow', 'adobe', 'noble', 'sweep'],
  ['based', 'apply', 'spook', 'elope', 'dykes'],
  ['amiss', 'mamma', 'impel', 'smelt', 'salty'],
  ['adage', 'domed', 'among', 'genie', 'edges'],
  ['clout', 'lease', 'oakum', 'usurp', 'tempo'],
  ['discs', 'idiom', 'sigma', 'comic', 'smack'],
  ['acids', 'comet', 'imbue', 'deuce', 'steel'],
  ['altar', 'llama', 'talon', 'among', 'range'],
  ['amble', 'moral', 'brand', 'lance', 'elder'],
  ['basal', 'apple', 'spoon', 'aloud', 'lends'],
  ['acids', 'camel', 'imbue', 'deuce', 'sleet'],
  ['backs', 'agent', 'cedar', 'knave', 'strew'],
  ['amiss', 'mamma', 'impel', 'smelt', 'salts'],
  ['beads', 'expel', 'apple', 'delve', 'sleek'],
  ['bands', 'aware', 'natal', 'drawl', 'sells'],
  ['bluff', 'liner', 'uncle', 'fells', 'fresh'],
  ['amass', 'mania', 'angel', 'siege', 'sales'],
  ['ached', 'crave', 'hazel', 'event', 'delta'],
  ['actor', 'chide', 'tibia', 'odium', 'reams'],
  ['amass', 'medal', 'adobe', 'sable', 'sleek'],
  ['basin', 'abide', 'sinew', 'ideal', 'newly'],
  ['acres', 'crime', 'rival', 'email', 'sells'],
  ['bales', 'abode', 'logic', 'edict', 'sects'],
  ['befit', 'evade', 'fakir', 'idiom', 'terms'],
  ['begot', 'elope', 'gotta', 'optic', 'teach'],
  ['based', 'apply', 'speak', 'elate', 'dykes'],
  ['bless', 'lance', 'endow', 'score', 'sewed'],
  ['bales', 'adult', 'lunar', 'elate', 'strew'],
  ['chaff', 'hello', 'alder', 'fleet', 'forth'],
  ['acted', 'crude', 'tulip', 'edict', 'depth'],
  ['beads', 'enrol', 'aroma', 'domes', 'slash'],
  ['altar', 'largo', 'trail', 'agile', 'roles'],
  ['busts', 'ultra', 'steal', 'tract', 'salty'],
  ['askew', 'smile', 'kinda', 'elder', 'weary'],
  ['acres', 'chime', 'rival', 'email', 'sells'],
  ['alive', 'laced', 'icing', 'venue', 'edges'],
  ['banks', 'alone', 'novel', 'knell', 'sells'],
  ['bolts', 'opera', 'legal', 'tract', 'salts'],
  ['bells', 'exult', 'lunar', 'llama', 'strap'],
  ['basic', 'abide', 'sibyl', 'idyll', 'cells'],
  ['bless', 'lance', 'endow', 'scope', 'sewed'],
  ['beans', 'endow', 'adobe', 'noble', 'sweet'],
  ['balls', 'avail', 'largo', 'light', 'sloth'],
  ['amiss', 'momma', 'impel', 'smelt', 'salts'],
  ['basic', 'aroma', 'sofas', 'image', 'cased'],
  ['agree', 'grill', 'rigid', 'elite', 'elder'],
  ['basic', 'aroma', 'sofas', 'image', 'cases'],
  ['alias', 'ladle', 'idiom', 'alone', 'semen'],
  ['balls', 'await', 'larva', 'liver', 'stark'],
  ['balls', 'again', 'larva', 'liver', 'snarl'],
  ['bands', 'avail', 'naive', 'dived', 'sleds'],
  ['blink', 'levee', 'ivory', 'nerve', 'keyed'],
  ['clasp', 'leper', 'apace', 'sects', 'press'],
  ['acted', 'chime', 'tidal', 'email', 'dells'],
  ['acted', 'crime', 'tidal', 'email', 'dells'],
  ['amass', 'march', 'argue', 'scull', 'shell'],
  ['balls', 'avail', 'larva', 'lives', 'slash'],
  ['beads', 'elbow', 'abode', 'dodge', 'sweep'],
  ['claps', 'lemon', 'ample', 'polka', 'sneak'],
  ['caper', 'abate', 'pasha', 'ethic', 'react'],
  ['beads', 'expel', 'apple', 'delve', 'sleep'],
  ['altar', 'larva', 'trial', 'avail', 'rally'],
  ['cedar', 'elite', 'dicta', 'attic', 'react'],
  ['beads', 'elbow', 'abide', 'dodge', 'sweet'],
  ['awful', 'where', 'feign', 'urged', 'lends'],
  ['brags', 'rural', 'aroma', 'gamin', 'slant'],
  ['clink', 'levee', 'ivory', 'nerve', 'keyed'],
  ['aback', 'baron', 'argue', 'coupe', 'kneel'],
  ['alpha', 'lyric', 'print', 'hinge', 'acted'],
  ['brags', 'rural', 'aroma', 'gamin', 'slang'],
  ['chess', 'hence', 'endow', 'scope', 'sewed'],
  ['adage', 'domed', 'among', 'genre', 'edges'],
  ['bears', 'eight', 'agree', 'rheum', 'stems'],
  ['askew', 'smile', 'kinda', 'elder', 'wears'],
  ['clips', 'level', 'ivory', 'peril', 'slyly'],
  ['aches', 'cheat', 'hedge', 'eagle', 'steel'],
  ['acres', 'clime', 'rival', 'email', 'sells'],
  ['amass', 'medal', 'adobe', 'sable', 'sleet'],
  ['acids', 'camel', 'imbue', 'deuce', 'sleek'],
  ['chess', 'hence', 'endow', 'scope', 'sewer'],
  ['chops', 'hovel', 'ovary', 'peril', 'slyly'],
  ['clasp', 'lance', 'angel', 'scent', 'pelts'],
  ['amass', 'might', 'agree', 'sheep', 'steps'],
  ['scamp', 'canoe', 'anvil', 'moist', 'pelts'],
  ['beans', 'equip', 'auger', 'niece', 'spree'],
  ['bells', 'equal', 'lumpy', 'lapel', 'slyly'],
  ['amass', 'march', 'argue', 'scull', 'shelf'],
  ['apart', 'paler', 'alibi', 'rebel', 'trill'],
  ['adage', 'doled', 'along', 'genie', 'edges'],
  ['dells', 'equal', 'lumpy', 'lapel', 'slyly'],
  ['chaff', 'hello', 'alder', 'fleck', 'forks'],
  ['brats', 'remit', 'amigo', 'tiger', 'storm'],
  ['bards', 'afire', 'rival', 'drawl', 'sells'],
  ['alive', 'laced', 'icing', 'venue', 'edged'],
  ['amiss', 'mamma', 'impel', 'smell', 'sally'],
  ['cased', 'apply', 'speak', 'elate', 'dykes'],
  ['ached', 'clove', 'hotel', 'event', 'delta'],
  ['discs', 'idiom', 'sigma', 'comes', 'smash'],
  ['calls', 'avail', 'largo', 'light', 'sloth'],
  ['balls', 'adult', 'lunar', 'llama', 'strap'],
  ['calms', 'avail', 'largo', 'might', 'sloth'],
  ['basal', 'ample', 'spoon', 'aloud', 'lends'],
  ['beams', 'enrol', 'argue', 'mouse', 'sleek'],
  ['chefs', 'hovel', 'every', 'feral', 'slyly'],
  ['aches', 'cheat', 'hedge', 'eagle', 'steep'],
  ['chaps', 'human', 'amuse', 'pasha', 'sneak'],
  ['altos', 'larva', 'trial', 'ovals', 'salsa'],
  ['bored', 'opine', 'rival', 'enact', 'delta'],
  ['askew', 'stile', 'kinda', 'elder', 'wears'],
  ['brats', 'remit', 'amigo', 'tiger', 'stork'],
  ['bulls', 'usual', 'lumpy', 'lapel', 'slyly'],
  ['bergs', 'exult', 'rupee', 'gleam', 'stems'],
  ['bless', 'lance', 'endow', 'score', 'sewer'],
  ['beans', 'elbow', 'above', 'novel', 'swell'],
  ['amass', 'medal', 'adobe', 'sabre', 'sleep'],
  ['acrid', 'credo', 'rebel', 'ideal', 'dolls'],
  ['amigo', 'model', 'idled', 'geese', 'olden'],
  ['blast', 'lance', 'annul', 'scull', 'tells'],
  ['abase', 'basil', 'asked', 'sieve', 'elder'],
  ['belts', 'equip', 'lunge', 'tiger', 'sperm'],
  ['abate', 'bacon', 'acute', 'totem', 'enemy'],
  ['claps', 'lemon', 'amble', 'polka', 'sneak'],
  ['corps', 'ochre', 'rheum', 'prune', 'semen'],
  ['fists', 'idiom', 'sigma', 'tombs', 'smash'],
  ['bears', 'endow', 'adage', 'rogue', 'sweep'],
  ['acrid', 'credo', 'revel', 'ideal', 'dolls'],
  ['flats', 'lilac', 'alibi', 'taboo', 'scion'],
  ['beads', 'elbow', 'abide', 'dodge', 'sweep'],
  ['bales', 'aroma', 'local', 'email', 'sally'],
  ['cobra', 'ocean', 'being', 'ranks', 'angst'],
  ['bears', 'endow', 'adage', 'rogue', 'sweet'],
  ['aches', 'cheap', 'hedge', 'eagle', 'speed'],
  ['acids', 'comet', 'imbue', 'deuce', 'steep'],
  ['basal', 'aroma', 'soapy', 'ample', 'layer'],
  ['acted', 'clime', 'tidal', 'email', 'dells'],
  ['chasm', 'hence', 'angel', 'scent', 'melts'],
  ['calls', 'axiom', 'lingo', 'logic', 'smock'],
  ['cased', 'apply', 'spook', 'elope', 'dykes'],
  ['dwarf', 'wider', 'adobe', 'rebus', 'fresh'],
  ['bases', 'adult', 'sugar', 'elate', 'strew'],
  ['brisk', 'revue', 'ivory', 'surge', 'keyed'],
  ['anger', 'nerve', 'groan', 'evade', 'renew'],
  ['chaff', 'hello', 'allay', 'flake', 'foyer'],
  ['bless', 'lathe', 'ethic', 'shift', 'sects'],
  ['altos', 'leapt', 'taper', 'opera', 'straw'],
  ['clips', 'light', 'igloo', 'photo', 'stool'],
  ['brags', 'rural', 'aroma', 'games', 'slash'],
  ['beads', 'endow', 'adage', 'dogma', 'swear'],
  ['aback', 'baron', 'aroma', 'comic', 'knack'],
  ['busts', 'ultra', 'steal', 'tract', 'salts'],
  ['adage', 'doled', 'along', 'genre', 'edges'],
  ['chips', 'hovel', 'ivory', 'peril', 'slyly'],
  ['bells', 'email', 'larva', 'lives', 'slash'],
  ['amigo', 'model', 'idled', 'geese', 'older'],
  ['cobra', 'ocean', 'being', 'range', 'angel'],
  ['chaff', 'hello', 'alder', 'fleet', 'forte'],
  ['acids', 'camel', 'imbue', 'deuce', 'sleep'],
  ['birds', 'idiom', 'ridge', 'dogma', 'smear'],
  ['busts', 'ultra', 'steal', 'trail', 'sally'],
  ['backs', 'alone', 'cocoa', 'knoll', 'seals'],
  ['amass', 'medal', 'adobe', 'sabre', 'sleet'],
  ['clout', 'lapse', 'opium', 'usurp', 'tempo'],
  ['clefs', 'level', 'every', 'feral', 'slyly'],
  ['chick', 'human', 'imbue', 'cause', 'knees'],
  ['amass', 'medal', 'adobe', 'sable', 'sleep'],
  ['clout', 'lease', 'oakum', 'usurp', 'temps'],
  ['corps', 'ochre', 'rheum', 'prude', 'semen'],
  ['adage', 'doled', 'along', 'genre', 'edged'],
  ['based', 'aptly', 'steak', 'elate', 'dykes'],
  ['amiss', 'momma', 'impel', 'smell', 'sally'],
  ['balls', 'axiom', 'lingo', 'logic', 'smock'],
  ['acted', 'clove', 'towel', 'event', 'delta'],
  ['amble', 'mural', 'brand', 'lance', 'elder'],
  ['apace', 'prior', 'aisle', 'colic', 'erect'],
  ['clips', 'light', 'igloo', 'photo', 'stoop'],
  ['fists', 'idiom', 'sigma', 'tomes', 'smash'],
  ['chaff', 'hello', 'allay', 'flame', 'foyer'],
  ['beams', 'enrol', 'argue', 'mound', 'sleds'],
  ['offal', 'fauna', 'fungi', 'angst', 'laity'],
  ['brace', 'relay', 'alibi', 'cabin', 'eying'],
  ['chaff', 'hello', 'alder', 'fleet', 'forts'],
  ['depot', 'elope', 'podia', 'opium', 'teams'],
  ['amass', 'medal', 'adobe', 'sabre', 'sleek'],
  ['brick', 'revue', 'ivory', 'curse', 'keyed'],
  ['cells', 'equal', 'lumpy', 'lapel', 'slyly'],
  ['bonds', 'odium', 'niece', 'ducal', 'smell'],
  ['askew', 'stile', 'kinda', 'elder', 'weary'],
  ['bands', 'aware', 'naval', 'drawl', 'sells'],
  ['discs', 'idiom', 'sigma', 'comer', 'smart'],
  ['seats', 'eight', 'agree', 'there', 'steel'],
  ['blast', 'lunch', 'anger', 'scene', 'three'],
  ['tests', 'extra', 'steal', 'trade', 'sales'],
  ['least', 'error', 'arena', 'songs', 'trash'],
  ['cards', 'alarm', 'radio', 'drink', 'smoke'],
  ['quote', 'ultra', 'other', 'treat', 'earth'],
  ['lists', 'ideal', 'sense', 'taste', 'sleep'],
  ['camps', 'alert', 'media', 'prior', 'start'],
  ['cause', 'alpha', 'upper', 'shell', 'early'],
  ['stars', 'throw', 'argue', 'route', 'sweet'],
  ['parts', 'apart', 'ratio', 'trial', 'stole'],
  ['plant', 'lower', 'aware', 'nerve', 'trees'],
  ['noble', 'ocean', 'beard', 'large', 'ended'],
  ['solve', 'onion', 'limit', 'voice', 'enter'],
  ['named', 'above', 'model', 'event', 'delta'],
  ['burst', 'unite', 'river', 'steam', 'terms'],
  ['twist', 'waste', 'issue', 'stunt', 'teeth'],
  ['brave', 'ruled', 'along', 'venue', 'edges'],
  ['frost', 'rifle', 'often', 'slept', 'tenth'],
  ['shoes', 'hello', 'older', 'elect', 'sorts'],
  ['react', 'eagle', 'again', 'clips', 'tense'],
  ['harsh', 'acute', 'rural', 'stamp', 'helps'],
  ['apple', 'plain', 'paint', 'liner', 'entry'],
  ['grass', 'right', 'agree', 'sheep', 'steps'],
  ['pages', 'adult', 'guide', 'elder', 'stern'],
  ['trust', 'ranch', 'under', 'scene', 'threw'],
  ['holds', 'opera', 'legal', 'drama', 'salad'],
  ['heard', 'error', 'arise', 'roses', 'dress'],
  ['wants', 'aware', 'naval', 'trail', 'sells'],
  ['phase', 'haven', 'avoid', 'seize', 'ended'],
  ['asset', 'solar', 'slate', 'eaten', 'trend'],
  ['grams', 'reset', 'aside', 'media', 'steak'],
  ['table', 'ahead', 'being', 'lance', 'edges'],
  ['merit', 'elite', 'risen', 'items', 'tense'],
  ['straw', 'teach', 'radio', 'acids', 'whose'],
]
